/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyStockIndentMap from './pharmacy-stock-indent-map';
import PharmacyStockIndentMapDetail from './pharmacy-stock-indent-map-detail';
import PharmacyStockIndentMapUpdate from './pharmacy-stock-indent-map-update';
import PharmacyStockIndentMapDeleteDialog from './pharmacy-stock-indent-map-delete-dialog';

const PharmacyStockIndentMapRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyStockIndentMap />} />
    <Route path="new" element={<PharmacyStockIndentMapUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyStockIndentMapDetail />} />
      <Route path="edit" element={<PharmacyStockIndentMapUpdate />} />
      <Route path="delete" element={<PharmacyStockIndentMapDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyStockIndentMapRoutes;
